import { useState } from "react";
import { usePatientInputByType } from "hooks";
import { PatientInput, PatientType } from "types";

type PatientInputHook = {
  patient: PatientInput;
  isRelationValid: boolean;
  isDetailsValid: boolean;
  onTypeChange(type: PatientType): void;
  onRelationChange(relation: string): void;
  onPatientChange(patient: PatientInput): void;
  onPatientFilesUploadChange(file: any): void;
};

const usePatientInput = (): PatientInputHook => {
  const [patient, setPatient] = useState<PatientInput>({});
  const patientByType = usePatientInputByType();

  const {
    type,
    firstName,
    middleName,
    lastName,
    gender,
    birthday,
    relation,
    agreement,
    uploadPatientFiles,
    patientDataSharingAgreement,
    ...concerns
  } = patient;

  const isRelationValid = Boolean(relation);
  const hasConcerns = Object.values(concerns).some(Boolean);
  const hasAgreed = agreement === "yes";
  const hasAgreedDataSharing = patientDataSharingAgreement === "yes";

  const isDetailsValid = [
    firstName,
    lastName,
    gender,
    birthday,
    relation,
    hasConcerns,
    hasAgreed,
    hasAgreedDataSharing
  ].every(Boolean);

  const onTypeChange = (type: PatientType) => {
    setPatient(patientByType[type]);
  };

  const onRelationChange = (relation: string) => {
    setPatient((old) => ({ ...old, relation }));
  };

  const onPatientChange = (patient: PatientInput) => {
    setPatient(patient);
  };

  const onPatientFilesUploadChange = (file: any) => {
    setPatient((old) => ({ ...old, uploadPatientFiles: file}))
  };
  
  return {
    patient,
    isRelationValid,
    isDetailsValid,
    onTypeChange,
    onRelationChange,
    onPatientChange,
    onPatientFilesUploadChange,
  };
};

export { usePatientInput };
